// Shared by the screen and the Excel export so column order and colors stay aligned.
export const reconciliationColumns = [
  { key: "fecha", accessor: "dia", label: "Día", width: "6%" },
  { key: "peaje", accessor: "peaje", label: "Peajes", width: "12%" },
  { key: "totalPasos", accessor: "totalPasos", label: "Total pasos", width: "9%" },
  {
    key: "gopassPasosExitosos",
    accessor: "gopassPasosExitosos",
    label: "Gopass Pasos Exitosos",
    width: "12%",
  },
  { key: "valorConcesion", accessor: "concesion", label: "Valor concesión", width: "10%" },
  {
    key: "diferenciaInicial",
    accessor: "diferenciaInicial",
    label: "Diferencia Inicial",
    width: "10%",
  },
  { key: "pagosRechazos", accessor: "pagosRechazos", label: "Pagos Rechazos", width: "10%" },
  { key: "totalGopass", accessor: "totalGopass", label: "Total Gopass", width: "10%" },
  { key: "diferenciaFinal", accessor: "diferenciaFinal", label: "Diferencia Final", width: "10%" },
  { key: "pagoFinanciera", accessor: "pagoFinanciera", label: "Pago financiera", width: "10%" },
  {
    key: "diferenciaFinanciera",
    accessor: "diferenciaFinanciera",
    label: "Diferencia Financiera",
    width: "10%",
  },
  {
    key: "valoresAdicionales",
    accessor: "valoresAdicionales",
    label: "Valores Adicionales",
    width: "10%",
  },
  { key: "descuentos", accessor: "descuentos", label: "Descuentos", width: "8%" },
  { key: "observacion", accessor: "observacion", label: "Observación", width: "18%" },
];
export const reconciliationColor = (index) =>
  index === 0 || index >= 13 ? "FFFFFF" : index <= 5 ? "E2EFDA" : index <= 8 ? "FFF2CC" : "DDEBF7";
export const reconciliationTableSx = (theme) => {
  const dark = theme.palette.mode === "dark";
  const date = theme.palette.background.paper;
  const green = dark ? "#263d30" : "#E2EFDA";
  const yellow = dark ? "#423b23" : "#FFF2CC";
  const blue = dark ? "#263b50" : "#DDEBF7";
  return {
    maxHeight: 850,
    isolation: "isolate",
    "& th, & td": {
      fontSize: "0.82rem",
      px: 2,
      py: 1.5,
      whiteSpace: "nowrap",
      borderBottom: "1px solid",
      borderColor: "divider",
      color: "text.primary",
    },
    "& thead": { display: "table-header-group" },
    "& th": { fontWeight: 700 },
    "& th:first-of-type, & td:first-of-type": {
      position: "sticky",
      left: 0,
      minWidth: 100,
      width: 100,
      maxWidth: 100,
      zIndex: 2,
      bgcolor: date,
    },
    "& th:nth-of-type(2), & td:nth-of-type(2)": {
      position: "sticky",
      left: 100,
      minWidth: 210,
      zIndex: 2,
    },
    "& th:nth-of-type(n+2):nth-of-type(-n+6), & td:nth-of-type(n+2):nth-of-type(-n+6)": {
      bgcolor: green,
    },
    "& th:nth-of-type(n+7):nth-of-type(-n+9), & td:nth-of-type(n+7):nth-of-type(-n+9)": {
      bgcolor: yellow,
    },
    "& th:nth-of-type(n+10):nth-of-type(-n+13), & td:nth-of-type(n+10):nth-of-type(-n+13)": {
      bgcolor: blue,
    },
    "& th:nth-of-type(6), & td:nth-of-type(6), & th:nth-of-type(9), & td:nth-of-type(9)": {
      borderRight: "2px solid",
      borderRightColor: dark ? "#607287" : "#9ba8b4",
    },
    "& th:nth-of-type(14), & td:nth-of-type(14)": {
      bgcolor: date,
      minWidth: 260,
      maxWidth: 360,
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      textAlign: "left",
    },
    "& th:nth-of-type(15), & td:nth-of-type(15)": { bgcolor: date, textAlign: "center" },
    "& thead th:first-of-type, & thead th:nth-of-type(2)": { zIndex: 4 },
    "& tbody tr:hover td": { boxShadow: "inset 0 0 0 9999px rgba(0,0,0,0.025)" },
    '& tbody tr:has([data-subtotal="true"]) td': {
      borderBottom: "1px solid",
      borderBottomColor: dark ? "#8494a5" : "#64748b",
      fontWeight: 700,
    },
    "& tfoot td": {
      position: "sticky",
      bottom: 0,
      zIndex: 3,
      borderTop: "2px solid",
      borderTopColor: dark ? "#8494a5" : "#64748b",
    },
    "& tfoot td:first-of-type, & tfoot td:nth-of-type(2)": { zIndex: 4 },
  };
};
